import React from "react";
import BottomBorder from "./BottomBorder";

// Icons
import CloseIcon from "../../../icons/CloseIcon";
import KeyIcon from "../../../icons/KeyIcon";

// Images
import TruBeLogo from "./TruBeLogo";
import twoxublack from "./2xu-black.png";

export const ElevatedClass = ({
  className,
  eventItem,
  // symbol,
  date,
  time,
  soldOut,
  confirmed,
  partnerLogo,
}) => (
  <div className={`${className} _tbk-h-75 tbk-relative  `}>
    <div className="tbk-flex tbk-flex-col tbk-items-center tbk-justify-center  tbk-bg-basic-white tbk-pt-7 tbk-pb-7">
      <BottomBorder className="tbk-absolute tbk-bottom-0 tbk-left-1/2 tbk--translate-x-1/2" />
      <div className="">
        <KeyIcon width="24" height="24" className="tbk-mx-auto tbk-mb-1" />
        <h2 className="tbk-text-secondary tbk-mb-4 tbk-text-blue-grey">
          TruBe Elevated Class
        </h2>
      </div>

      <div className="tbk-mb-2">
        {partnerLogo ? (
          <div className="tbk-mb-2 tbk-flex tbk-items-center">
            <TruBeLogo />
            <CloseIcon
              width="16"
              height="16"
              className="tbk-mx-2 tbk-text-blue-grey"
            />
            <img src={partnerLogo} style={{ height: "27px" }} />
          </div>
        ) : null}
        <div className=" tbk-text-main tbk-mb-2 tbk-text-center tbk-text-primary lg:tbk-hidden">
          {date}
          <br />
          {time}
        </div>
      </div>

      {soldOut || confirmed ? (
        <div
          className={`tbk-text-h3-subtitle ${
            soldOut ? "tbk-uppercase tbk-text-coral" : "tbk-text-green"
          }`}
        >
          {soldOut ? "Sold out" : "You're confirmed"}
        </div>
      ) : (
        <div className="tbk-p-1">
          <p className="tbk-text-secondary tbk-text-center tbk-text-blue-grey">
            For members only
            <br />
            Upcharge: {(eventItem && eventItem.price.symbol) || "$"}
            {eventItem && eventItem.price.amount}
          </p>
        </div>
      )}
    </div>
  </div>
);
